import {ERROR} from 'src/pages/answerflow/constants/views';
import {fragment} from 'src/pages/scheduleCallback/utils';
import {changeView} from 'src/shared/currentView/actions';
import {logScreenName} from 'src/shared/dataLayer/loggers';
import {pushHistory} from 'src/shared/history/actions';

export const errorStep = () => dispatch => {
  dispatch(pushHistory(errorStep(), fragment('error')));
  dispatch(changeView(ERROR));
  logScreenName('error');
};
